import React from 'react';

export const Error = ({gqlError}) => <>
    {gqlError?.message || gqlError?.graphQLErrors[0]?.message || "Error"}
</>